var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 46,
    viewBox: "0 0 49 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2327_1593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4055 35.6662V30.0045C16.4055 28.5592 17.7352 27.3876 19.3755 27.3876H25.3714C26.1591 27.3876 26.9145 27.6633 27.4715 28.1541C28.0284 28.6448 28.3413 29.3104 28.3413 30.0045V35.6662C28.3363 36.2671 28.6038 36.8448 29.0842 37.2713C29.5647 37.6977 30.2184 37.9375 30.9003 37.9375H34.991C36.9015 37.9419 38.7355 37.2762 40.0882 36.0874C41.4408 34.8986 42.2011 33.2844 42.2011 31.601V15.4716C42.2011 14.1118 41.517 12.822 40.3332 11.9495L26.4174 2.15672C23.9967 0.439707 20.5284 0.495145 18.18 2.28839L4.58177 11.9495C3.34204 12.7962 2.60107 14.0899 2.56445 15.4716V31.5845C2.56445 35.0932 5.7925 37.9375 9.77451 37.9375H13.7718C15.1881 37.9375 16.3392 36.9306 16.3495 35.6827L16.4055 35.6662Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2327_1593",
    x: 0.564453,
    y: 0.905273,
    width: 47.6367,
    height: 45.0322,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2327_1593"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2327_1593",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.ad0adbec9bab1062875520943b5e4e58.svg";
export { ForwardRef as ReactComponent };